import ChannelContext from '@jetshop/core/components/ChannelContext';
import t from '@jetshop/intl';
import React, { useContext } from 'react';
import styled from 'react-emotion';

import { ProductGrid } from '../CategoryPage/ProductGrid';

const RelatedProductsTitle = styled.h2`
  font-size: 1.2em;
  padding-bottom: 3px;
  border-bottom: 1px dotted #cdcdcd;
  line-height: 1.4;
  font-weight: bold;
  color: #444;
  margin-bottom: 10px;
`;

const RelatedProductsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  margin-bottom: 40px;

  ${p => p.theme.below.md} {
    margin-top: 15px;
  }
`;

const stockStatusTextMap = {
  1: {
    culture: 'sv-SE',
    stockStatusTextInStock: 'I lager',
    stockStatusTextBestSeller: 'Tillfälligt slut - kommer snart  igen!'
  },
  2: {
    culture: 'fi-FI',
    stockStatusTextInStock: 'Varastossa',
    stockStatusTextBestSeller: 'Loppuunmyyty - saapuu pain!'
  },
  3: {
    culture: 'et-EE',
    stockStatusTextInStock: 'Kohe saadaval',
    stockStatusTextBestSeller: 'Välja müüdud - saabub varsti!'
  },
  4: {
    culture: 'da-DK',
    stockStatusTextInStock: 'På lager',
    stockStatusTextBestSeller: 'Brugerdefineret status 1'
  },
  5: {
    culture: 'en-GB',
    stockStatusTextInStock: 'In Stock',
    stockStatusTextBestSeller: ' Temporarily sold out - Soon back in stock!'
  }
};

const RelatedProducts = ({ relatedProducts, loading }) => {
  const { selectedChannel } = useContext(ChannelContext);
  const relatedProductsCopy = [...relatedProducts];
  const channelId = selectedChannel.id;

  const sortedProducts = relatedProducts.reduce(
    (acc, product) => {
      if (acc.standardProducts.length + acc.bestSellerProducts.length === 8) {
        return acc;
      } else {
        if (
          product.stockStatus.text ===
          stockStatusTextMap[channelId]?.stockStatusTextInStock
        ) {
          acc.standardProducts.push(product);
        } else {
          const bestSellerIndex = relatedProductsCopy.findIndex(
            product =>
              product.stockStatus.text ===
              stockStatusTextMap[channelId]?.stockStatusTextBestSeller
          );

          if (bestSellerIndex !== -1) {
            acc.bestSellerProducts.push(relatedProductsCopy[bestSellerIndex]);

            relatedProductsCopy.splice(bestSellerIndex, 1);
          }
        }
      }

      acc.combinedProducts = [
        ...acc.standardProducts,
        ...acc.bestSellerProducts
      ];

      return acc;
    },
    { standardProducts: [], bestSellerProducts: [], combinedProducts: null }
  );

  const relatedProductsSorted = relatedProducts.slice(0, 8);

  if (!relatedProductsSorted || relatedProductsSorted.length === 0) return null;

  return (
    <RelatedProductsWrapper>
      <RelatedProductsTitle>{t('Related products')}</RelatedProductsTitle>

      <ProductGrid
        listName="related-products"
        products={relatedProductsSorted}
        loading={loading}
        imageSizes={[1 / 2, 1 / 2, 1 / 2, 1 / 2]}
      />
    </RelatedProductsWrapper>
  );
};

export default RelatedProducts;
